import About from "./components/About";
import Contact from "./components/Contact";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Skills from "./components/Skills";
import Works from "./components/Works";

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Skills />
      <Works />
      <About />
      <Contact />
    </div>
  );
}

export default App;
